export default __webpack_public_path__ + "static/media/registerImage.0996fb72.svg";